/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
export function useTooltipControllerSharedState() {
  var state = React.useMemo(function () {
    return {
      ignoreNonTouchEvents: false,
      timers: {
        enter: null,
        leave: null,
        touch: null
      }
    };
  }, []);
  React.useEffect(function () {
    return function () {
      window.clearTimeout(state.timers.enter);
      window.clearTimeout(state.timers.leave);
      window.clearTimeout(state.timers.touch);
    };
  }, []);
  return state;
}